module.exports = __webpack_public_path__ + "static/media/newsletter.c65885af.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/newsletter.png
// module id = 386
// module chunks = 0